
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { debugLog } from '../../../utils/debugLogger';

/**
 * Hook that handles redirects based on authentication state.
 * 
 * SIMPLIFIED: Only redirects authenticated users AWAY from auth pages.
 * Protected routes (admin, profilo, etc.) are handled by dedicated route guards.
 */
export const useAuthRedirects = (
  user: any,
  isAuthenticated: boolean,
  isLoading: boolean,
  authResolved: boolean
) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Only handle: redirect authenticated users away from login/register pages
    if (isAuthenticated) {
      if (currentPath === '/auth/register') {
        debugLog('auth', 'User registered, redirecting to profile', undefined, 'AuthRedirects');
        navigate('/profilo', { replace: true });
      } else if (currentPath === '/auth/login' || currentPath === '/login') {
        debugLog('auth', 'User is authenticated, redirecting from login page', undefined, 'AuthRedirects');
        navigate('/', { replace: true });
      }
    }
  }, [isAuthenticated, location, navigate]);
};
